<template>
  <!-- Tam ekran engelleyici: sunucuya ulaşılamadığı sürece kapatılamaz, arkadaki hiçbir
       elemana tıklanamaz (Dialog + closable=false + close-on-escape=false). -->
  <Dialog :visible="baglanti.kesikMi" modal :closable="false" :close-on-escape="false"
    :draggable="false" :dismissable-mask="false" style="width: 90vw; max-width: 420px">
    <div class="flex flex-col items-center text-center gap-3 py-2">
      <i class="pi pi-wifi text-4xl renk-olumsuz"></i>
      <div class="font-bold text-lg">Sunucuya bağlanılamıyor</div>
      <div class="text-sm text-gray-500 dark:text-gray-400">
        İnternet bağlantınızda bir sorun olabilir. Bağlantı otomatik olarak kontrol ediliyor,
        lütfen bekleyin — sayfa yeniden bağlanınca kendiliğinden devam edecek.
      </div>
      <i class="pi pi-spin pi-spinner text-2xl text-primary mt-2"></i>
    </div>
  </Dialog>

  <!-- Bağlantı döndü ama kesinti anında bir KAYDET/SIL isteği yanıtsız kaldı — otomatik
       "başarılı" varsayılmıyor, kullanıcı açıkça uyarılıp kontrol etmesi isteniyor. -->
  <Dialog v-model:visible="baglanti.uyariGoster" modal :draggable="false" style="width: 90vw; max-width: 460px">
    <template #header>
      <span class="font-bold text-lg flex items-center gap-2">
        <i class="pi pi-exclamation-triangle renk-uyari"></i> Bağlantı yeniden kuruldu
      </span>
    </template>
    <div class="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
      Bağlantı kesintiye uğradığı sırada yaptığınız <strong>son kaydetme/silme işleminin</strong>
      sunucuya ulaşıp ulaşmadığı kesin değil. Lütfen ilgili kaydı kontrol edin; gerekiyorsa
      işlemi tekrarlayın.
    </div>
    <template #footer>
      <Button label="Anladım" @click="baglanti.uyariGoster = false" />
    </template>
  </Dialog>
</template>

<script>
import { baglantiState } from '@/services/baglanti';

export default {
  name: 'BaglantiKesintisi',
  data() {
    return { baglanti: baglantiState };
  },
};
</script>
